import script from "./AppFooterCertificates.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppFooterCertificates.vue?vue&type=script&setup=true&lang=ts"

import "./AppFooterCertificates.vue?vue&type=style&index=0&id=75d40448&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75d40448"]])

export default __exports__